import SlateBlock from './SlateBlock';
export default SlateBlock;